export default __webpack_public_path__ + "static/media/android_fr_pwa.f7187287.png";